// extracted by mini-css-extract-plugin
export default {"item":"Item_item__rNa8V","icon":"Item_icon__YwMpv","title":"Item_title__y0vzm","content":"Item_content__wBfVR"};